export default "__VITE_ASSET__zED1Bj7R__"